import { InputType } from "@/utils/step_config_utils";
import { StaticImageData } from "next/image";
import { ReactNode } from "react";

// Define types for our configuration
export type FormField = {
  type: "text" | "number" | "select" | "checkbox" | "link" | "custom" | "tel" | "email" | "fiscalCodeHelperTool" | "privacyOptions" | "schoolAndCourseSelector" | "newSchoolAndCourseSelector" | "city";
  inputType?: InputType;
  name: string;
  label: Record<string, string>; // Localized labels
  required?: boolean;
  schools?: StepSchoolsInfo
  requirements?: {
    minLength?: number;
    maxLength?: number;
    min?: number;
    max?: number;
    pattern?: string;
  }
  autocomplete?: string;
  extra?: ExtraInfo;
  placeholder?: Record<string, string>; // Localized labels
  children?: ReactNode;
  options?: Array<{
    value: any;
    label: Record<string, string>;
  }>;
  validation?: {
    pattern?: string;
    min?: number;
    max?: number;
  };
};

export type StepSchoolsInfo = {
  schoolCourseTypologies?: string[];
  customSchoolCourseTypologies?: {
    name: Record<string, string>;
    value: string;
  }[];
  schoolUuids?: string[];
  disabled: boolean;
};

export type ExtraInfo = {
  uppercase?: boolean;
};

export type InfoItem = {
  icon: string;
  text: Record<string, string>;
};

export type Info = {
  title?: Record<string, string>;
  titleIcon?: string;
  items?: InfoItem[];
  node?: ReactNode;
};

export enum WizardLayout {
  BUTTON_FIELDS = "BUTTON_FIELDS",
  FIELDS_BUTTONS = "FIELDS_BUTTONS",
}

export type StepConfig = {
  id: string,
  title: Record<string, string>;
  subTitle?: Record<string, string>;
  description: Record<string, string>;
  fields?: FormField[];
  layout: WizardLayout;
  nextButtonText?: Record<string, string>;
  backButtonText?: Record<string, string>;
  info?: Info;
  error?: Record<string, Record<string, Record<string, string>>>;
};

export type ConfigBorder = {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
}


export type ConfigParternshipRight = {
  background?: string;
  border?: ConfigBorder;
  logoSize?: number[];
};

export type ConfigParternshipLogo = {
  name: string;
  url: string;
  logoSize?: number[];
  link?: string;
}

export type ConfigParternship = {
  name: string;
  logo?: string | ConfigParternshipLogo[];
  logoSize?: number[];
  link?: string;
  right?: ConfigParternshipRight;
};

export type WizardConfigHabacus = {
  logo?: string;
  left?: {
    mode: "light" | "dark"
  };
  top?: {
    mode: "light" | "dark",
    color?: string
  };
}

export type WizardConfig = {
  tenant: string;
  version: string;
  bankMetaName?: string;
  habacus?: WizardConfigHabacus;
  parternship?: ConfigParternship,
  steps: Record<string, StepConfig>;
  resultPage?: {
    title: Record<string, string>;
    description: Record<string, string>;
    nextButtonText?: Record<string, string>;
    backButtonText?: Record<string, string>;
    info?: Info;
    error?: Record<string, Record<string, Record<string, string>>>;
  };
};


interface ControlMiddlewareRouteFunctions {
  [key: string]: string;
}

export type ControlMiddlewareFunctions = {
  routes?: ControlMiddlewareRouteFunctions
}

export type ControlFunctions = {
  middlewareFunctions?: ControlMiddlewareFunctions
}